import { toast } from "react-toastify";

export const validateAddEditParameterFun = ({
  addParameterRuleData,
  getAllParametesRules,
  setRebalanceRequired,
  adjustTargetParams,
  isDelete = false,
}) => {
  if (
    !addParameterRuleData.param_name ||
    !addParameterRuleData.param_name.trim()
  ) {
    toast.error("Please enter Parameter name");
    return false;
  }

  if (!addParameterRuleData.weight) {
    toast.error("Please enter Weight");
    return false;
  }

  if (!addParameterRuleData.type) {
    toast.error("Please select Category");
    return false;
  }

  const weight = Number(addParameterRuleData.weight);

  const rules = (addParameterRuleData.rules || []).filter(
    (rule) => rule.status !== 0
  );

  for (let i = 0; i < rules.length; i++) {
    const rule = rules[i];

    if (!rule.rule_name || !rule.rule_name.trim()) {
      toast.error(`Condition is required for Rule ${i + 1}`);
      return false;
    }

    if (rule.score === "" || rule.score === null || rule.score === undefined) {
      toast.error(`Score is required for Rule ${i + 1}`);
      return false;
    }
  }

  if (rules.length > 0) {
    const scores = rules.map((r) => Number(r.score || 0));

    const exceedWeight = scores.some((s) => s > weight);
    const hasEqualWeight = scores.includes(weight);
    const allSame = scores.every((s) => s === scores[0]);

    if (exceedWeight) {
      toast.error(`Rule score should not exceed parameter weight (${weight})`);
      return false;
    }

    if (!hasEqualWeight) {
      toast.error(
        `One rule score must be equal to the parameter weight (${weight})`
      );
      return false;
    }

    if (allSame && scores.length > 1) {
      toast.error("All rule scores should not be the same");
      return false;
    }
  }

  const targetParams = adjustTargetParams || [];
  const hasTargetParams = targetParams.length > 0;

  for (let i = 0; i < targetParams.length; i++) {
    const param = targetParams[i];

    if (
      param.weight === "" ||
      param.weight === null ||
      param.weight === undefined
    ) {
      toast.error(`Weight is required for Target Parameter ${i + 1}`);
      return false;
    }

    const paramWeight = Number(param.weight);

    const paramRules = (param.rules || []).filter((r) => r.status !== 0);

    // if (paramRules.length === 0) {
    //   toast.error(
    //     `At least one rule is required for Target Parameter ${i + 1}`
    //   );
    //   return false;
    // }

    for (let j = 0; j < paramRules.length; j++) {
      const rule = paramRules[j];

      if (!rule.rule_name || !rule.rule_name.trim()) {
        toast.error(
          `Condition is required for Target Parameter ${i + 1} - Rule ${j + 1}`
        );
        return false;
      }

      // if (
      //   rule.score
      // ) {
      //   toast.error(
      //     `Score is required for Target Parameter ${i + 1} - Rule ${j + 1}`
      //   );
      //   return false;
      // }
    }

    const scores = paramRules.map((r) => Number(r.score || 0));

    const exceedWeight = scores.some((s) => s > paramWeight);
    const hasEqualWeight = scores.includes(paramWeight);
    const allSame = scores.every((s) => s === scores[0]);

    if (exceedWeight) {
      toast.error(
        `Rule score should not exceed weight (${paramWeight}) in Target Parameter ${
          i + 1
        }`
      );
      return false;
    }

    if (!hasEqualWeight) {
      toast.error(
        `One rule score must equal weight (${paramWeight}) in Target Parameter ${
          i + 1
        }`
      );
      return false;
    }

    if (allSame && scores.length > 1) {
      toast.error(
        `All rule scores should not be the same in Target Parameter ${i + 1}`
      );
      return false;
    }
  }

  var existingWeightTotal = (getAllParametesRules || [])
    .filter((param) => param.param_id !== addParameterRuleData.param_id)
    .reduce((sum, param) => sum + Number(param.weight || 0), 0);

  const currentWeight = Number(addParameterRuleData.weight);

  const totalTargetWeight = targetParams.reduce(
    (sum, param) => sum + Number(param.weight || 0),
    0
  );
  const targetIds = (adjustTargetParams || []).map((t) => t.param_id);

  const matchedTargetWeight = (getAllParametesRules || [])
    .filter((param) => targetIds.includes(param.param_id))
    .reduce((sum, param) => sum + Number(param.weight || 0), 0);
  if (hasTargetParams) {
    existingWeightTotal = existingWeightTotal - Number(matchedTargetWeight);
  }
  console.log(
    hasTargetParams,
    existingWeightTotal,
    currentWeight,
    totalTargetWeight,
    addParameterRuleData.param_id
  );
  if (!hasTargetParams) {
    const totalWeight = isDelete
      ? existingWeightTotal
      : existingWeightTotal + currentWeight;
    if (totalWeight > 100) {
      setRebalanceRequired(true);
      toast.error("Total parameter weight in this category cannot exceed 100 ");
      return false;
    }

    if (totalWeight < 100) {
      const remaining = 100 - totalWeight;

      setRebalanceRequired(true);

      toast.error(
        `Total weight is ${totalWeight}. Please allocate remaining ${remaining} using target parameters`
      );

      return false;
    }
  } else {
    const totalWeight = isDelete
      ? existingWeightTotal
      : existingWeightTotal + currentWeight;
    const totalCombinedWeight = totalWeight + totalTargetWeight;

    if (totalCombinedWeight > 100) {
      toast.error(
        "Total of source and target parameter weights cannot exceed 100"
      );
      return false;
    }

    if (totalCombinedWeight < 100) {
      const remaining = 100 - totalCombinedWeight;

      toast.error(
        `Please adjust target parameters by ${remaining} to reach 100`
      );

      return false;
    }
  }

  return true;
};
